// extracted by mini-css-extract-plugin
export var quillEditor = "_me-1";
export var variable = "_me-0";